import {
  DashboardOutlined,
  MessageOutlined,
  CalendarOutlined,
  CarOutlined,
  CustomerServiceOutlined,
  SettingOutlined,
  CompassOutlined,
  BarChartOutlined,
  BellOutlined,
  EnvironmentOutlined,
  AlertOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "fleet-dashboard",
    path: `${APP_PREFIX_PATH}/fleet-dashboard`,
    title: "",
    icon: DashboardOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "fleet-dashboard",
        path: `${APP_PREFIX_PATH}/fleet-dashboard/home`,
        title: "Fleet",
        icon: CarOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "fleet-live-tracking",
        path: `${APP_PREFIX_PATH}/fleet-dashboard/live-tracking`,
        title: "Live Tracking",
        icon: EnvironmentOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "fleet-trip-planning",
        path: `${APP_PREFIX_PATH}/trip-planning`,
        title: "Trip Planning",
        icon: CompassOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-default",
        path: `${APP_PREFIX_PATH}/services/all`,
        title: "Services",
        icon: CustomerServiceOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "fleet-emergency-services",
        path: `${APP_PREFIX_PATH}/emergency-services`,
        title: "Emergency",
        icon: AlertOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "bookings",
        path: `${APP_PREFIX_PATH}/bookings/home`,
        title: "Bookings",
        icon: CalendarOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "fleet-announcements",
        path: `${APP_PREFIX_PATH}/announcements`,
        title: "Announcements",
        icon: BellOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-messages",
        path: `${APP_PREFIX_PATH}/apps/chat`,
        title: "Messages",
        icon: MessageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-settings",
        path: `${APP_PREFIX_PATH}/pages/setting/edit-profile`,
        title: "Settings",
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const mechanicNavTree = [
  {
    key: "mechanic-dashboard",
    path: `${APP_PREFIX_PATH}/mechanic`,
    title: "",
    icon: DashboardOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "mechanic-home",
        path: `${APP_PREFIX_PATH}/mechanic/dashboard`,
        title: "Home",
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "mechanic-services",
        path: `${APP_PREFIX_PATH}/mechanic/services`,
        title: "Services",
        icon: CustomerServiceOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "mechanic-bookings",
        path: `${APP_PREFIX_PATH}/mechanic/bookings`,
        title: "Bookings",
        icon: CalendarOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "mechanic-ads-analytics",
        path: `${APP_PREFIX_PATH}/mechanic/ads-analytics`,
        title: "Ads Analytics",
        icon: BarChartOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "mechanic-announcements",
        path: `${APP_PREFIX_PATH}/announcements`,
        title: "Announcements",
        icon: BellOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "mechanic-messages",
        path: `${APP_PREFIX_PATH}/apps/chat`,
        title: "Messages",
        icon: MessageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "mechanic-settings",
        path: `${APP_PREFIX_PATH}/mechanic/settings/edit-profile`,
        title: "Settings",
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const driverNavTree = [
  {
    key: "driver-root",
    path: `${APP_PREFIX_PATH}/driver/home`,
    title: "",
    icon: DashboardOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "driver-home",
        path: `${APP_PREFIX_PATH}/driver/home`,
        title: "Home",
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-default",
        path: `${APP_PREFIX_PATH}/services/all`,
        title: "Services",
        icon: CustomerServiceOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "driver-trip-planning",
        path: `${APP_PREFIX_PATH}/trip-planning`,
        title: "Trip Planning",
        icon: EnvironmentOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "driver.my-trips",
        path: `${APP_PREFIX_PATH}/driver/my-trips`,
        title: "My Trips",
        icon: CompassOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "driver-emergency-services",
        path: `${APP_PREFIX_PATH}/emergency-services`,
        title: "Emergency",
        icon: AlertOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "driver-earnings",
        path: `${APP_PREFIX_PATH}/driver/earnings`,
        title: "Earnings",
        icon: DollarOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "bookings",
        path: `${APP_PREFIX_PATH}/bookings/home`,
        title: "Bookings",
        icon: CalendarOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "driver-announcements",
        path: `${APP_PREFIX_PATH}/announcements`,
        title: "Announcements",
        icon: BellOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-messages",
        path: `${APP_PREFIX_PATH}/apps/chat`,
        title: "Messages",
        icon: MessageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "dashboards-settings",
        path: `${APP_PREFIX_PATH}/pages/setting/edit-profile`,
        title: "Settings",
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree];

export const mechanicNavigationConfig = [...mechanicNavTree];
export const driverNavigationConfig   = [...driverNavTree];

export default navigationConfig;
